export const qtdTotalDepentes = (dependentes) => {
  const qtdDependentes = dependentes.length
  return qtdDependentes;
};